var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"head-inner"},[_c('div',[_c('div',[_vm._v("资源工具池")]),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v("你想要的资源工具应有尽有")])]),_c('div',{staticStyle:{"padding-top":"28px"}},[_c('img',{staticStyle:{"width":"540px","height":"272px"},attrs:{"src":require("../assets/images/zyTools.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }